import {ApplicationConfig, LOCALE_ID, provideBrowserGlobalErrorListeners, provideZoneChangeDetection,} from '@angular/core';
import {provideRouter} from '@angular/router';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';

import {MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions,} from '@angular/material/core';

import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getAuth, provideAuth} from '@angular/fire/auth';
import {getFirestore, provideFirestore} from '@angular/fire/firestore';
import {getStorage, provideStorage} from '@angular/fire/storage';

import {registerLocaleData} from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import localeNlExtra from '@angular/common/locales/extra/nl';
import {Settings} from 'luxon';

import {routes} from './app.routes';
import {environment} from '../environments/environment';
import {authInterceptor} from './_interceptors/auth.interceptor';

/* ----------------------------------------------------
 * Locale & Luxon setup (executed once)
 * ---------------------------------------------------- */

if (environment.language === 'nl') {
  registerLocaleData(localeNl, 'nl-NL', localeNlExtra);
  Settings.defaultLocale = 'nl';
}

Settings.defaultZone = 'Europe/Amsterdam';

/* ----------------------------------------------------
 * Date formats
 * ---------------------------------------------------- */

const DATE_FORMATS =
  environment.language === 'nl'
    ? {
      parse: { dateInput: 'dd-MM-yyyy' },
      display: {
        dateInput: 'dd-MM-yyyy',
        monthYearLabel: 'MMMM yyyy',
        dateA11yLabel: 'dd-MM-yyyy',
        monthYearA11yLabel: 'MMMM yyyy',
      },
    }
    : {
      parse: { dateInput: 'MM/dd/yyyy' },
      display: {
        dateInput: 'MM/dd/yyyy',
        monthYearLabel: 'MMMM yyyy',
        dateA11yLabel: 'MM/dd/yyyy',
        monthYearA11yLabel: 'MMMM yyyy',
      },
    };

/* ----------------------------------------------------
 * Material global ripple config
 * ---------------------------------------------------- */

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true,
  animation: {
    enterDuration: 300,
    exitDuration: 0,
  },
};

/* ----------------------------------------------------
 * API / PLATFORM CONFIG
 * ---------------------------------------------------- */

export const apiConfig: ApplicationConfig = {
  providers: [
    /* Angular core */
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),

    /* Firebase */
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    /* HTTP */
    provideHttpClient(withInterceptors([
      authInterceptor,
    ])),

    /* Locale */
    {
      provide: LOCALE_ID,
      useValue: environment.language === 'nl' ? 'nl-NL' : 'en-US',
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: environment.language === 'nl' ? 'nl-NL' : 'en-US',
    },

    /* Material */
    {
      provide: MAT_DATE_FORMATS,
      useValue: DATE_FORMATS,
    },
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: globalRippleConfig,
    },
  ],
};
